import { render, staticRenderFns } from "./AssessmentQuestion.vue?vue&type=template&id=6cb1667c"
import script from "./AssessmentQuestion.vue?vue&type=script&lang=js"
export * from "./AssessmentQuestion.vue?vue&type=script&lang=js"
import style0 from "./AssessmentQuestion.vue?vue&type=style&index=0&id=6cb1667c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports